module.exports = __webpack_public_path__ + "7012b52df95a36744fedc53ce2af3c80.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_l_60.mp3
// module id = 455
// module chunks = 0